import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, ReplaySubject, share, shareReplay, Subject, tap } from 'rxjs';

import { ENVIRONMENT, Environment } from '@environment';
import { UsheruApi } from '@usheru-hff/shared/data-access-backend';
import { ConsumerLead } from '@usheru-hff/shared/domain';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  readonly leadChanges$ = new Subject<ConsumerLead>();
  constructor(
    private usheruApi: UsheruApi,
    @Inject(ENVIRONMENT) private env: Environment,
    private http: HttpClient
  ) {}

  putConsumerLead(consumerLead: ConsumerLead): Observable<ConsumerLead> {
    const requestOrContinue$ = this.env.avoidSubscriptionPostApiRequest
      ? of(consumerLead)
      : this.http.put<ConsumerLead>(`${this.env.api.url}/consumer-lead`, consumerLead, {
          headers: this.usheruApi.getStandardHeader()
        });

    return requestOrContinue$.pipe(
      tap(() => this.leadChanges$.next(consumerLead)),
      shareReplay(1)
    );
  }
}
